// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"tableOverflow_tableWrap__3hZYr","ellipsis":"tableOverflow_ellipsis__ciNpj","ellipsisCell":"tableOverflow_ellipsisCell__17qnU"};